/**
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/assetSetExpirationView.html';

import Form from '@netx/core/functionality/form';

import 'bootstrap-datepicker';
import moment from '@netx/core/lib/netx-moment';

export default class AssetSetExpirationView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.eventStr = opts.eventStr || 'asset:expire';
		opts.headerTitle = opts.headerTitle || i18n.t('i18n.setExpiration');
		opts.hideOnSubmit = opts.hideOnSubmit !== false;
		opts.id = opts.id || 'asset-set-expiration-view';
		opts.template = opts.template || Template;

		super(opts);
	}

	/** @override */
	preRender() {
		super.preRender();

		// Check for expiration date
		let expirationDate = this.model.get('expirationDate');
		if (expirationDate) {
			// Gives us that YYYY-MM-DD
			expirationDate = moment(expirationDate).format('YYYY-MM-DD');
		}

		// Tomorrows date
		const tomorrow = moment().add(1, 'day').endOf('day');

		// Additional template vars
		_.extend(this.templateVars, {
			expirationDate: expirationDate,
			// Gives us that YYYY-MM-DD
			startDate: tomorrow.format('YYYY-MM-DD'),
		});
	}

	/** @type {string} */
	static get __name__() {
		return 'AssetSetExpirationView';
	}
}

// Functionality
Form(AssetSetExpirationView);
